import React, { useState, useEffect } from "react";
import axiosMain from "../http/axiosMain";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import mainlogo from "../Assets/Img/insocialorbitlog.svg"; // Adjust the path as necessary

const AddCoinsModal = ({ open, onClose }) => {
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    // Ensure Razorpay script is loaded
    const scriptId = "razorpay-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const handleProceed = async () => {
    if (!amount || Number(amount) <= 0) {
      setSnackbar({
        open: true,
        message: "Please enter a valid amount",
        severity: "error",
      });
      return;
    }

    try {
      setLoading(true);

      const response = await axiosMain.post("/api/user/wallet/add-money", {
        amount: Number(amount),
      });

      const data = response?.data?.data;

      if (!data?.order_id || !data?.amount || !data?.currency) {
        throw new Error("Invalid payment data received");
      }

      const options = {
        key: "rzp_test_pK3Coo0TBxuw2S", // Your test key
        amount: data.amount,
        currency: data.currency,
        name: "Insocial Orbit",
        description: "Add Coins to Wallet",
        image: mainlogo, // ✅ Your logo URL here

        order_id: data.order_id,
        handler: function (response) {
          console.log("Payment Success:", response);
          setSnackbar({
            open: true,
            message: "Payment successful!",
            severity: "success",
          });
          onClose();
        },
        prefill: {
          name: "User Name",
          email: "user@example.com",
          contact: "9999999999",
        },
        theme: {
          color: "#6b8e76",
        },
      };

      if (window.Razorpay) {
        const rzp = new window.Razorpay(options);

        // Optional: Handle payment failure
        rzp.on("payment.failed", function (response) {
          console.error("Payment Failed:", response.error);
          setSnackbar({
            open: true,
            message: "Payment failed. Please try again.",
            severity: "error",
          });
        });

        rzp.open();
      } else {
        throw new Error("Razorpay SDK not loaded");
      }
    } catch (error) {
      console.error("Error during Razorpay process:", error);
      setSnackbar({
        open: true,
        message: error?.message || "Failed to start payment. Try again.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", pb: 1 }}>
          Add Coins to Your Wallet
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8, color: "grey.500" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pt: 0 }}>
          <Typography
            variant="subtitle2"
            align="center"
            gutterBottom
            sx={{
              pt: 0,
              color: "rgba(101, 101, 101, 1)",
              fontWeight: 500,
              fontSize: "18px",
            }}
          >
            1 Rupees = 1 Coin
          </Typography>

          <Box mt={2}>
            <Typography
              gutterBottom
              sx={{
                color: "rgba(18, 18, 18, 1)",
                fontWeight: 500,
                fontStyle: "Medium",
                fontSize: "16px",
                lineHeight: "20px",
                letterSpacing: "0px",
              }}
            >
              Enter Amount
            </Typography>
            <Box
              component="input"
              type="number"
              placeholder="Enter Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              sx={{
                width: "100%",
                padding: "10px 14px",
                fontSize: "14px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                outline: "none",
                "&:focus": {
                  borderColor: "#4f6f52",
                },
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <Button
            variant="contained"
            onClick={handleProceed}
            disabled={loading}
            sx={{
              backgroundColor: "rgba(107, 142, 118, 1)",
              textTransform: "none",
              fontWeight: 500,
              px: 4,
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "rgba(107, 142, 118, 1)",
                boxShadow: "none",
              },
            }}
          >
            {loading ? "Processing..." : "Proceed to Pay"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddCoinsModal;
